import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate(
        
        router: ActivatedRouteSnapshot,
        state: RouterStateSnapshot

    ) :Observable<boolean> | boolean {

        if( this.authService.isSuperAdmin ) {
            
            return true;
       
        }

        this.router.navigate(['login']);

        return false;
           
    }
}
